<script>
const SECONDS_TO_SESSION_CLEARING = 30

export default {
  name: 'TimeoutAlert',
  data: function () {
    return {
      timer: SECONDS_TO_SESSION_CLEARING
    }
  },
  mounted() {
    window.timerInterval = setInterval(() => {
      this.timer > 1 ? this.timer-- : this.clearSession()
    }, 1000)
  },
  beforeDestroy() {
    clearInterval(window.timerInterval)
  },
  methods: {
    clearSession() {
      clearInterval(window.timerInterval)
      this.$store.commit('setTimeoutAlertVisibility', false)
      this.$killSession({ performDeliveryResign: false })
    }
  }
}
</script>

<template lang="pug">
transition(name="fade")
  .timeout-alert
    .timeout-alert__inner
      h1.timeout-alert__timer.text-primary
        span 00:
        span(v-if="timer < 10") 0
        span {{ timer }}
      .text-center
        h3.mb-0 {{ $t('sessionWillEndSoon') }}
</template>

<style scoped lang="scss">
@import '@/assets/styles/variables.scss';

.timeout-alert {
  position: fixed;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;

  background: rgba(0, 0, 0, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;

  .timeout-alert__inner {
    padding: 5rem 6rem;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    width: 36rem;
    border-radius: 3rem;
    background: white;

    .timeout-alert__timer {
      font-size: 7rem;
      line-height: 1;
      margin-bottom: 2rem;
    }
  }
}
</style>
